// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"vqsj98d7UTSjLCVkLomZs"};